import CustomInput from "@/components/ui/form/CustomInput";
import CustomTextarea from "@/components/ui/form/CustomTextarea";
import RenderFieldError from "@/components/ui/form/RenderFieldError";
import { TTestimonialFormData } from "@/schema/testimonialSchema";

type TTestimonialFormFields = {
  errors?: Record<string, string>;
  data: TTestimonialFormData;
  onChangeValue: (field: keyof TTestimonialFormData, value: string) => void;
};

const TestimonialFormFields = ({
  errors,
  data,
  onChangeValue,
}: TTestimonialFormFields) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <CustomInput
            placeholder="First name"
            name="firstName"
            value={data.firstName}
            onChange={(e) => onChangeValue("firstName", e.target.value)}
          />
          {errors?.firstName && (
            <RenderFieldError errors={errors} fieldName="firstName" />
          )}
        </div>

        <div>
          <CustomInput
            placeholder="Last name"
            name="lastName"
            value={data.lastName}
            onChange={(e) => onChangeValue("lastName", e.target.value)}
          />
          {errors?.lastName && (
            <RenderFieldError errors={errors} fieldName="lastName" />
          )}
        </div>
      </div>

      <div>
        <CustomInput
          placeholder="Linkedin url"
          name="linkedInUrl"
          value={data.linkedInUrl}
          onChange={(e) => onChangeValue("linkedInUrl", e.target.value)}
        />
        {errors?.linkedInUrl && (
          <RenderFieldError errors={errors} fieldName="linkedInUrl" />
        )}
      </div>

      <div>
        <CustomTextarea
          maxLength={350}
          placeholder="Message"
          rows={8}
          name="message"
          className="resize-none"
          value={data.message}
          onChange={(e) => onChangeValue("message", e.target.value)}
        />
        {errors?.message && (
          <RenderFieldError errors={errors} fieldName="message" />
        )}
      </div>
    </div>
  );
};

export default TestimonialFormFields;
